module.exports = __webpack_public_path__ + "img/hero02.964b965c.jpg";